:host {
  display: flex;
  flex-direction: column;
}

ul {
  display: contents;
  list-style-type: none;
}